// extracted by mini-css-extract-plugin
module.exports = {"container":"df5dab2e92--container--d4QJq","title":"df5dab2e92--title--k5kbf"};